import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { experiencesCreateEvent, ServiceEventResource } from '~/generated';
import { extractData } from '~/utils/query-utils';

type CreateEventParams = {
  experienceId: number;
  requestBody: ServiceEventResource;
};

export const useCreateEvent = (
  options: UseMutationOptions<
    ServiceEventResource,
    unknown,
    CreateEventParams,
    unknown
  > = {}
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: CreateEventParams) => {
      return extractData(
        experiencesCreateEvent({
          path: { experienceId: data.experienceId },
          body: data.requestBody,
        })
      );
    },
    ...options,
    onSuccess(data, variables, mutationResult, context) {
      queryClient.invalidateQueries({
        queryKey: ['Experiences'],
      });
      options.onSuccess?.(data, variables, mutationResult, context);
    },
  });
};
